import './social_content_context_view.js.coffee';# Added by Script 
Monitoring.Views ||= {}

class Monitoring.Views.SocialContentParentCommentView extends Monitoring.Views.SocialContentContextView

  initialize: (@options = {}) ->
    super(@options)
    @$resultsContainer = @$el.find('#parent_comment')

  noResultsMessage: ->
    'PARENT COMMENT NOT FOUND'

  formatResults: ->
    @$resultsContainer.before(@moreContextLinkHtml())
    super()